import { render } from "./SidebarButton.vue?vue&type=template&id=58e8cb25"
import script from "./SidebarButton.vue?vue&type=script&lang=js"
export * from "./SidebarButton.vue?vue&type=script&lang=js"
script.render = render

export default script